import type { NewsPost } from "./types";
import fbzFirstBirthday from "./posts/2026-05-28-fangbreaker-zone-turns-one.html?raw";

export const NEWS_POSTS_PER_PAGE = 10;

export const newsPosts = [  
  {
    title: "A Year of Fangbreaker.zone & The Start of Frostreaver.zone [Part 1]",
    date: "2026-05-28",
    slug: "first-birthday-part-1",
    excerpt:
      "The sites first birthday: A retrospective, part one.",
    html: fbzFirstBirthday,
  },
] satisfies NewsPost[];

export function getNewsPost(date: string | undefined, slug: string | undefined) {
  if (!date || !slug) {
    return undefined;
  }

  return newsPosts.find((post) => post.date === date && post.slug === slug);
}

export function getNewsPostPath(post: Pick<NewsPost, "date" | "slug">) {
  return `/posts/${post.date}/${post.slug}`;
}

export function getNewsArchivePageCount() {
  return Math.max(1, Math.ceil(newsPosts.length / NEWS_POSTS_PER_PAGE));
}

export function getNewsArchivePage(pageNumber: number) {
  const startIndex = (pageNumber - 1) * NEWS_POSTS_PER_PAGE;
  return newsPosts.slice(startIndex, startIndex + NEWS_POSTS_PER_PAGE);
}

export function formatNewsDate(date: string) {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${date}T00:00:00Z`));
}
